module.exports = __webpack_public_path__ + "img/DEQ.png";